import { render, staticRenderFns } from "./Sldentify.vue?vue&type=template&id=5c498384&"
import script from "./Sldentify.vue?vue&type=script&lang=js&"
export * from "./Sldentify.vue?vue&type=script&lang=js&"
import style0 from "./Sldentify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports